<div class="mat-typography" [formGroup]="bookmarkFg">
    <div class="dialog-header">
        {{data?.bookmark ? 'Rename Bookmark':'Save current map view' }}
    </div>
    <div class="horizontal-separator"></div>

    <div class="dialog-container">
        <p class="input-label">
            Bookmark name
        </p>
        <mat-form-field appearance="outline">
            <input matInput formControlName="name" placeholder="Name" required>
            @if (bookmarkFg.get('name')?.hasError('required')) {
                <mat-error>
                    Name is required
                </mat-error>
            }
            @if (bookmarkFg.get('name')?.hasError('pattern')) {
                <mat-error>
                    Name contains forbidden characters <, >, :, ", /, \, |, ?, *
                </mat-error>
            }
            @if (fieldError('name')) {
                <mat-error>
                    {{fieldError('name')}}
                </mat-error>
            }
        </mat-form-field>
    </div>

</div>
<div class="button-row ">
    <button mat-button mat-dialog-close class="cancel-button" >Cancel</button>
    <button mat-button cdkFocusInitial class="frmg-primary-button" [disabled]="bookmarkFg.invalid"
            (click)="addBookmark()">
        {{data?.bookmark ? 'Save changes':'Save bookmark' }}
    </button>
</div>
